document.addEventListener("DOMContentLoaded", function() {
  let docSelected = null;
  let prevCategory = null;
  const deptoMunicipios = {
    "Guatemala": ["Ciudad de Guatemala", "Mixco", "Fraijanes"],
    "Sacatepéquez": ["Antigua Guatemala"],
    "Quetzaltenango": ["Xela"]
  };

  function refreshElements() {
    return {
      select: document.getElementById("documento"),
      nitContainer: document.getElementById("nitContainer"),
      nitInput: document.getElementById("nit"),
      nitValido: document.querySelector(".nit-valido"),
      nitInvalido: document.querySelector(".nit-invalido"),
      nitSinGuion: document.querySelector(".nit-sin-guion"),
      dpiContainer: document.getElementById("dpiContainer"),
      dpiInput: document.getElementById("dpivalue"),
      dpiValido: document.querySelector(".dpi-valido"),
      dpiInvalido: document.querySelector(".dpi-invalido"),
      dpiSinGuion: document.querySelector(".dpi-sin-guion"),
      pasaporteContainer: document.getElementById("pasaporteContainer"),
      pasaporteInput: document.getElementById("pasaportevalue"),
      pasaporteValido: document.querySelector(".pasaporte-valido"),
      pasaporteInvalido: document.querySelector(".pasaporte-invalido"),
      pasaporteSinGuion: document.querySelector(".pasaporte-sin-guion"),
      botonCheckout: document.getElementById("CheckOut"),
      departamento: document.getElementById("departamento"),
      municipio: document.getElementById("municipio")
    };
  }

  let elems = refreshElements();

  function getTotal() {
    let totalEl = document.querySelector(".cart__total strong.text-size--heading");
    if (!totalEl) return 0;
    let t = totalEl.textContent.trim().replace(/^[A-Za-z]/, "").replace(/,/g, "");
    return parseFloat(t) || 0;
  }

  function validarDPI(dpi) {
    if (dpi.length !== 13) return false;
    const p = dpi.substr(0, 8);
    if (!/^\d{8}$/.test(p)) return false;
    const u = dpi.substr(8, 4);
    if (!/^\d{4}$/.test(u)) return false;
    const s = [...p, ...u].map((d, i) => (i % 2 === 0 ? d * 2 : d * 1))
      .map(d => (d > 9 ? d - 9 : d)).reduce((acc, d) => acc + d, 0);
    const ult = parseInt(dpi.charAt(12));
    return ((s + ult) % 10 === 0);
  }

  function validaPasaporte(p) {
    if (!/^.{6,9}$/.test(p)) return false;
    if (!/^[A-Z]{2}/.test(p)) return false;
    if (!/^[A-Z\d]+$/i.test(p.substr(2))) return false;
    return true;
  }

  function valNit(nit) {
    var nd, add = 0;
    if ((nd = /^(\d+)([\dk])$/i.exec(nit))) {
      nd[2] = nd[2].toLowerCase() === "k" ? 10 : parseInt(nd[2]);
      for (let i = 0; i < nd[1].length; i++) {
        add += ((i - nd[1].length) * -1 + 1) * nd[1][i];
      }
      return (11 - (add % 11)) % 11 === nd[2];
    }
    return false;
  }

  function generarOpcionesDocumento() {
    const currentTotal = getTotal();
    const options = currentTotal < 2500 
      ? [
          { value: "CF", label: "C/F" },
          { value: "Nit", label: "NIT" },
          { value: "Dpi", label: "DPI" },
          { value: "Pasaporte", label: "Pasaporte" }
        ]
      : [
          { value: "Nit", label: "NIT" },
          { value: "Dpi", label: "DPI" },
          { value: "Pasaporte", label: "Pasaporte" }
        ];

    if (!docSelected) {
      docSelected = currentTotal < 2500 ? "CF" : "Nit";
    }

    if (elems.select) {
      elems.select.innerHTML = options
        .map(opt => `<option value="${opt.value}" ${opt.value === docSelected ? "selected" : ""}>${opt.label}</option>`)
        .join("");
    }
  }

  function updateDisplay() {
    if (docSelected === "CF") {
      elems.nitContainer.style.display = "none";
      elems.dpiContainer.style.display = "none";
      elems.pasaporteContainer.style.display = "none";
    } else if (docSelected === "Nit") {
      elems.nitContainer.style.display = "block";
      elems.dpiContainer.style.display = "none";
      elems.pasaporteContainer.style.display = "none";
    } else if (docSelected === "Dpi") {
      elems.nitContainer.style.display = "none";
      elems.dpiContainer.style.display = "flex";
      elems.pasaporteContainer.style.display = "none";
    } else if (docSelected === "Pasaporte") {
      elems.nitContainer.style.display = "none";
      elems.dpiContainer.style.display = "none";
      elems.pasaporteContainer.style.display = "flex";
    }
  }

  function verificarCheckout() {
    const currentTotal = getTotal();
    
    if (currentTotal < 2500) {
      if (docSelected === "CF") {
        elems.botonCheckout.disabled = false;
      } else if (docSelected === "Nit") {
        elems.botonCheckout.disabled = !valNit(elems.nitInput.value);
      } else if (docSelected === "Dpi") {
        elems.botonCheckout.disabled = !validarDPI(elems.dpiInput.value);
      } else if (docSelected === "Pasaporte") {
        elems.botonCheckout.disabled = !validaPasaporte(elems.pasaporteInput.value);
      }
    } else {
      if (docSelected === "Nit") {
        elems.botonCheckout.disabled = !valNit(elems.nitInput.value);
      } else if (docSelected === "Dpi") {
        elems.botonCheckout.disabled = !validarDPI(elems.dpiInput.value);
      } else if (docSelected === "Pasaporte") {
        elems.botonCheckout.disabled = !validaPasaporte(elems.pasaporteInput.value);
      }
    }
  }

  function actualizarMunicipios() {
    const municipioSelect = document.getElementById("municipio");
    const deptoSeleccionado = document.getElementById("departamento").value;
    
    municipioSelect.innerHTML = "";
    
    if (deptoMunicipios[deptoSeleccionado]) {
      const defaultOption = document.createElement("option");
      defaultOption.value = "";
      defaultOption.textContent = "Seleccione su municipio";
      municipioSelect.appendChild(defaultOption);
      
      deptoMunicipios[deptoSeleccionado].forEach(function(municipio) {
        const opt = document.createElement("option");
        opt.value = municipio;
        opt.textContent = municipio;
        municipioSelect.appendChild(opt);
      });
    } else {
      const opt = document.createElement("option");
      opt.value = "";
      opt.textContent = "No hay municipios disponibles";
      municipioSelect.appendChild(opt);
    }
  }

  document.getElementById("departamento").addEventListener("change", actualizarMunicipios);

  document.getElementById("documento").addEventListener("change", function(e) {
    docSelected = e.target.value;
    updateDisplay();
    verificarCheckout();
  });

  elems.nitInput.addEventListener("input", function() {
    if (docSelected === "Nit") {
      if (this.value === "") {
        elems.nitSinGuion.style.display = "none";
        elems.nitInvalido.style.display = "none";
        elems.nitValido.style.display = "none";
        elems.botonCheckout.disabled = true;
      } else if (!valNit(this.value)) {
        if (this.value.includes("-")) {
          elems.nitSinGuion.style.display = "block";
          elems.nitInvalido.style.display = "none";
        } else {
          elems.nitSinGuion.style.display = "none";
          elems.nitInvalido.style.display = "block";
        }
        elems.nitValido.style.display = "none";
        elems.botonCheckout.disabled = true;
      } else {
        elems.nitInvalido.style.display = "none";
        elems.nitValido.style.display = "block";
        elems.nitSinGuion.style.display = "none";
        elems.botonCheckout.disabled = false;
      }
    }
  });

  elems.dpiInput.addEventListener("input", function() {
    if (docSelected === "Dpi") {
      if (this.value === "") {
        elems.dpiSinGuion.style.display = "none";
        elems.dpiInvalido.style.display = "none";
        elems.dpiValido.style.display = "none";
        elems.botonCheckout.disabled = true;
      } else if (!validarDPI(this.value)) {
        if (this.value.includes("-")) {
          elems.dpiSinGuion.style.display = "block";
          elems.dpiInvalido.style.display = "none";
        } else {
          elems.dpiSinGuion.style.display = "none";
          elems.dpiInvalido.style.display = "block";
        }
        elems.dpiValido.style.display = "none";
        elems.botonCheckout.disabled = true;
      } else {
        elems.dpiInvalido.style.display = "none";
        elems.dpiValido.style.display = "block";
        elems.dpiSinGuion.style.display = "none";
        elems.botonCheckout.disabled = false;
      }
    }
  });

  elems.pasaporteInput.addEventListener("input", function() {
    if (docSelected === "Pasaporte") {
      if (this.value === "") {
        elems.pasaporteSinGuion.style.display = "none";
        elems.pasaporteInvalido.style.display = "none";
        elems.pasaporteValido.style.display = "none";
        elems.botonCheckout.disabled = true;
      } else if (!validaPasaporte(this.value)) {
        if (this.value.includes("-")) {
          elems.pasaporteSinGuion.style.display = "block";
          elems.pasaporteInvalido.style.display = "none";
        } else {
          elems.pasaporteSinGuion.style.display = "none";
          elems.pasaporteInvalido.style.display = "block";
        }
        elems.pasaporteValido.style.display = "none";
        elems.botonCheckout.disabled = true;
      } else {
        elems.pasaporteInvalido.style.display = "none";
        elems.pasaporteValido.style.display = "block";
        elems.pasaporteSinGuion.style.display = "none";
        elems.botonCheckout.disabled = false;
      }
    }
  });

  document.addEventListener("click", function(e) {
    if (e.target.closest(".qty-button") || e.target.closest(".cart-remove")) {
      setTimeout(() => {
        window.location.reload();
      }, 1500);
    }
  });

  generarOpcionesDocumento();
  updateDisplay();
  verificarCheckout();
  actualizarMunicipios();
});